import { CatalogService } from "./CatalogService";
import { AppServices } from "../../config/entities";
import { generateUrlWithParams } from "../../helpers/UrlHelper";

export class ContractService extends CatalogService {
  async Clone(id: string) {
    const newObject = await this.Get(id);
    const clonedObject = { ...newObject };
    console.log("clonedObject is", clonedObject);
    return clonedObject;
  }

  async GetAllByVendorCustomer(
    searchText: string | undefined,
    vendorCustomerId: string | undefined
  ) {
    console.log(`GetAllVendor ${1}`, searchText);
    let url = generateUrlWithParams("contracts", {
      searchText: searchText,
      vendorCustomerId: vendorCustomerId,
    }); //this.catalogName;
    console.log(url);
    console.log("-----------------------------------");
    // if (searchText) {
    //     url += "?searchText=" + searchText;
    // }
    // if (vendorCustomerId) {
    //     url += "?vendorCustomerId=" + vendorCustomerId;
    // }

    const response = await AppServices.Axios.get(url);
    const filteredVendors = response.data.filter((x: any) => x.vendorCustomerId === vendorCustomerId);
    
    return filteredVendors;
  }
}
